import React, { useState, useEffect } from "react";
import '../../index.css';

const initialRoutes = [
    { id: 1, name: "Train", routeNumber: "101", routeType: "Train", status: "Active" },
    { id: 2, name: "Bus", routeNumber: "202", routeType: "Bus", status: "Active" },
];

export default function TransportRoute() {

    const STORAGE_KEY = "routes";
    const [routeList, setRouteList] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const [formData, setFormData] = useState({
        id: "",
        name: "",
        routeNumber: "",
        routeType: "",
        status: "Active",
        from: "",
        to: "",

    });
    const [errors, setErrors] = useState({});
    //  VALIDATION
    const validate = () => {
        let newErrors = {};

        if (!formData.name) {
            newErrors.name = "Route name is required";
        } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
            newErrors.name = "Only letters allowed";
        }

        if (!formData.routeNumber) {
            newErrors.routeNumber = "Route number is required";
        } else if (!/^[0-9]+$/.test(formData.routeNumber)) {
            newErrors.routeNumber = "Only numbers allowed";
        }

        return newErrors;
    };

    // 🔍 FILTER
    const filteredRoutes = routeList.filter((r) =>
        r.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        r.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
        r.from?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        r.to?.toLowerCase().includes(searchTerm.toLowerCase())

    );


    // ADD
    const openAddModal = () => {
        setIsEdit(false);
        setFormData({
            id: "",
            name: "",
            routeNumber: "",
            routeType: "",
            status: "Active",
            from: "",
            to: "",

        });
        setShowModal(true);
    };

    // EDIT
    const openEditModal = (route) => {
        setSelectedRoute(route);
        setIsEdit(true);
        setFormData(route);
        setShowModal(true);
    };

    // DELETE COMMON
    const deleteRouteById = (id) => {
        const updated = routeList.filter((r) => r.id !== id);
        setRouteList(updated);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        window.dispatchEvent(new Event("storage"));
        setSelectedRoute(null);
    };

    const handleDelete = () => {
        if (!selectedRoute) return alert("Select a route first");
        deleteRouteById(selectedRoute.id);
    };

    const handleRowDelete = (id) => {
        deleteRouteById(id);
    };

    // SAVE
    const handleSave = () => {
        const validationErrors = validate();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        if (new Date(formData.to) <= new Date(formData.from)) {
            alert("End date must be greater than Start date");
            return;
        }

        let updatedList = [];

        if (isEdit) {
            updatedList = routeList.map((r) =>
                r.id === formData.id ? formData : r
            );
        } else {
            updatedList = [
                { ...formData, id: Date.now() },
                ...routeList
            ];
        }

        setRouteList(updatedList);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList));
        window.dispatchEvent(new Event("storage"));

        setShowModal(false);
        setSelectedRoute(null);
        setErrors({});
    };
    // LOAD DATA
    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

        if (saved.length === 0) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(initialRoutes));
            setRouteList(initialRoutes);
        } else {
            setRouteList(saved);
        }
    }, []);

    // SYNC
    useEffect(() => {
        const handleStorage = () => {
            const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
            setRouteList(saved);
        };

        window.addEventListener("storage", handleStorage);
        return () => window.removeEventListener("storage", handleStorage);
    }, []);

    return (
        <>
            <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header { display:flex; justify-content:space-between; margin-bottom:10px; }
        .controls { display:flex; gap:10px; margin-bottom:10px; flex-wrap:wrap; }

        .search-box {
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .btn { padding:7px 12px; border:none; border-radius:4px; cursor:pointer; }
        .btn-dark { background:#2c3e50; color:white; }
        .btn-blue { background:#3498db; color:white; }
        .btn-red { background:#e74c3c; color:white; }

        table { width:100%; border-collapse:collapse; }
        th, td { padding:10px; border-bottom:1px solid #eee; }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }

        .status { color:green; }

        .action-btn {
          border:none;
          background:transparent;
          cursor:pointer;
          margin-right:5px;
        }

        .modal {
          position:fixed;
          top:0; left:0;
          width:100%; height:100%;
          background:rgba(0,0,0,0.5);
          display:flex;
          justify-content:center;
          align-items:center;
        }

        .modal-content {
          background:white;
          padding:20px;
          border-radius:8px;
          width:350px;
        }

        .modal-content input,
        .modal-content select {
          width:100%;
          margin-bottom:10px;
          padding:8px;
        }
          .input-error {
  border: 1px solid #e74c3c;
}

.error-text {
  color: #e74c3c;
  font-size: 12px;
  margin-bottom: 8px;
  display: block;
}
      `}</style>

            <div className="page">
                <div className="card">

                    <div className="header">
                        <h3>Transport Routes</h3>
                        <div>{routeList.length} Records</div>
                    </div>

                    <div className="controls">
                        <input
                            className="search-box"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        <button className="btn btn-dark" onClick={openAddModal}>
                            + Add Route
                        </button>

                        <button className="btn btn-blue" onClick={() => {
                            if (!selectedRoute) return alert("Select a route first");
                            openEditModal(selectedRoute);
                        }}>
                            Update
                        </button>

                        <button className="btn btn-red" onClick={handleDelete}>
                            Delete
                        </button>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Route Name</th>
                                <th>Route Number</th>
                                <th>Route Type</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredRoutes.map((r) => (
                                <tr
                                    key={r.id}
                                    className={selectedRoute?.id === r.id ? "active-row" : ""}
                                    onClick={() =>
                                        setSelectedRoute(selectedRoute?.id === r.id ? null : r)
                                    }
                                >
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedRoute?.id === r.id}
                                            onChange={() =>
                                                setSelectedRoute(selectedRoute?.id === r.id ? null : r)
                                            }
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                    </td>

                                    <td>{r.name}</td>
                                    <td>{r.routeNumber}</td>
                                    <td>{r.routeType}</td>
                                    <td>{r.from}</td>
                                    <td>{r.to}</td>
                                    <td className="status">{r.status}</td>


                                    <td>
                                        <button
                                            className="action-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                openEditModal(r);
                                            }}
                                        >
                                            ✏
                                        </button>

                                        <button
                                            className="action-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleRowDelete(r.id);
                                            }}
                                        >
                                            ❌
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>

                {showModal && (
                    <div className="modal">
                        <div className="modal-content">

                            <h3>{isEdit ? "Update Route" : "Add Route"}</h3>

                            <input
                                placeholder="Route Name"
                                value={formData.name}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFormData({ ...formData, name: value });

                                    setErrors({
                                        ...errors,
                                        name: !value
                                            ? "Route name is required"
                                            : !/^[A-Za-z\s]+$/.test(value)
                                                ? "Only letters allowed"
                                                : ""
                                    });
                                }}
                                className={errors.name ? "input-error" : ""}
                            />
                            {errors.name && <small className="error-text">{errors.name}</small>}

                            <input
                                placeholder="Route Number"
                                value={formData.routeNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFormData({ ...formData, routeNumber: value });

                                    setErrors({
                                        ...errors,
                                        routeNumber: !value
                                            ? "Route number required"
                                            : !/^[0-9]+$/.test(value)
                                                ? "Only numbers allowed"
                                                : ""
                                    });
                                }}
                                className={errors.routeNumber ? "input-error" : ""}
                            />
                            {errors.routeNumber && <small className="error-text">{errors.routeNumber}</small>}

                            <select
                                value={formData.routeType}
                                onChange={(e) =>
                                    setFormData({ ...formData, routeType: e.target.value })
                                }
                            >
                                <option value="Bus">Select</option>
                                <option value="Bus">Bus</option>
                                <option value="Auto">Auto</option>
                                <option value="Taxi">Taxi</option>
                            </select>

                            <input
                                placeholder="From Destination"
                                value={formData.from}
                                onChange={(e) =>
                                    setFormData({ ...formData, from: e.target.value })
                                }
                            />

                            <input
                                placeholder="To Destination"
                                value={formData.to}
                                onChange={(e) =>
                                    setFormData({ ...formData, to: e.target.value })
                                }
                            />

                            <select
                                value={formData.status}
                                onChange={(e) =>
                                    setFormData({ ...formData, status: e.target.value })
                                }
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>


                            <div style={{ display: "flex", gap: "10px" }}>
                                <button className="btn btn-blue" onClick={handleSave}>
                                    Save
                                </button>

                                <button
                                    className="btn btn-red"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </div>
                )}
            </div>
        </>
    );
}